@if (resolvedProduct(); as product) {
  <div class="product-compact-price">
    @let isNotAvailable = !(product | sdProductIsAvailable);

    @if (isNotAvailable && (!transitInstance() || !isTransitSelected())) {
      <div class="is-not-available text-b2-s-500">товар отсутствует</div>
    } @else {
      <div class="formatted-price-wrapper">
        @if (isPersonalPrice()) {
          <span class="personal-price-title text-b4-s-500">ваша цена</span>
        }
        @let mainPrice = price()?.formattedValue;
        @if (mainPrice) {
          <div
            class="formatted-price"
            [class.is-crossed]="secondaryPrice()"
            [class.is-crossed-personal]="isPersonalPrice()"
          >
            <span class="price-main text-h6-s">{{ mainPrice }}</span>
            @if (isRentProduct()) {
              <span class="price-rent text-b2-s-500">/24ч</span>
            }
            @if (secondaryPrice() && showSecondaryPrice()) {
              <span class="price-crossed text-b2-s-700">
                {{ secondaryPrice()?.formattedValue }}
              </span>
            }
          </div>
        }
      </div>
    }
  </div>
}
